import type { GridApiPremium, GridDataSource, GridPaginationModel } from "@mui/x-data-grid-premium";
import type { RefObject } from "react";
import { useCallback, useState } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import { GRID_DEFAULT_PAGE_SIZE } from "@entrilia/shared/components/grid/gridHelper";
import { logError } from "@entrilia/shared/logging";
import type { Approval } from "../../../api/types/approvalTypes";
import { approvalsGridColumnDefinitions } from "./approvalsGridProvider";

const gridPaginationModel: GridPaginationModel = { page: 0, pageSize: GRID_DEFAULT_PAGE_SIZE };

interface Props {
  dataSource: GridDataSource;
  apiRef?: RefObject<GridApiPremium | null>;
}

const ReviewedApprovalsGrid = ({ dataSource, apiRef }: Props) => {
  const [dataSourceError, setDataSourceError] = useState<Error>();

  const handleDataSourceError = useCallback((error: Error) => {
    logError(error, "[EmailDeliveryLogGrid]");
    setDataSourceError(error);
  }, []);

  if (dataSourceError) {
    return <DataLoadingFailed title="Loading approvals failed" />;
  }

  return (
    <DataGrid<Approval>
      apiRef={apiRef}
      columns={approvalsGridColumnDefinitions}
      lazyLoading
      dataSource={dataSource}
      paginationModel={gridPaginationModel}
      onDataSourceError={handleDataSourceError}
      noRowsText="No approvals"
      disableColumnPinning
      disableColumnReorder
      disableColumnSorting
      disableMultipleRowSelection
    />
  );
};

export default ReviewedApprovalsGrid;
